export default __webpack_public_path__ + "static/media/lifong02.b38f8f3a.png";